<section
  class="weightage-score-table"
  [class.weightage-score-table--fill-height]="fillHeightEnabled"
  [ngStyle]="tableStyle"
>
  <header class="weightage-score-table__header" *ngIf="title || subtitle">
    <h1 *ngIf="title">{{ title }}</h1>
    <p *ngIf="subtitle">{{ subtitle }}</p>
  </header>

  <div class="weightage-score-table__surface">
    <div class="weightage-score-table__state" *ngIf="loading">
      {{ data?.messages?.loading || 'Loading...' }}
    </div>

    <div class="weightage-score-table__state weightage-score-table__state--error" *ngIf="!loading && errorMessage">
      {{ errorMessage }}
    </div>

    <div class="weightage-score-table__shell" *ngIf="showTable" [ngStyle]="shellStyle">
      <table class="weightage-score-table__table">
        <colgroup>
          <col class="weightage-score-table__col weightage-score-table__col--group" />
          <col class="weightage-score-table__col weightage-score-table__col--meta" />
          <col *ngFor="let column of visibleColumns" [style.width]="column.width || null" />
        </colgroup>

        <thead>
          <tr>
            <th class="weightage-score-table__blank" colspan="2"></th>
            <th *ngFor="let column of visibleColumns" [ngStyle]="headerStyle" [style.text-align]="column.align || 'center'">
              {{ column.header }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of flatRows; trackBy: trackByRow" [ngStyle]="getRowToneStyle(item.row)">
            <td
              *ngIf="item.showSectionMeta"
              class="weightage-score-table__group"
              [attr.rowspan]="item.rowSpan"
              [ngStyle]="getGroupCellStyle(item.section)"
            >
              <span>{{ item.section.groupLabel }}</span>
            </td>

            <td
              *ngIf="item.showSectionMeta"
              class="weightage-score-table__meta"
              [attr.rowspan]="item.rowSpan"
              [ngStyle]="getSectionMetaStyle(item.section)"
            >
              <span class="weightage-score-table__axis">{{ item.section.axisLabel }}</span>
              <strong>{{ item.section.axisTitle }}</strong>
            </td>

            <td *ngFor="let column of visibleColumns" [ngStyle]="getColumnStyle(column)">
              <span
                class="weightage-score-table__cell"
                [class.weightage-score-table__cell--factor]="column.key === 'factor'"
                [class.weightage-score-table__cell--weight]="column.key === 'weight'"
              >
                {{ getCellValue(item.row, column) }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="weightage-score-table__source" *ngIf="showTable && sourceNote">{{ sourceNote }}</p>
  </div>
</section>
